import React from "react";
import { Tooltip } from "antd";

import "../../styles/pages/prism/prismText.scss";

const isEmptyValue = (value) =>
  value === null || value === undefined || value === "";

const PrismTruncatedText = ({
  value,
  formatter = (text) => text,
  children,
  tooltipContent,
  lines = 1,
  emptyText = "-",
  className = "",
}) => {
  const formattedValue = isEmptyValue(value) ? emptyText : formatter(value);
  const displayContent = children ?? formattedValue;
  const isEmpty =
    children == null &&
    (isEmptyValue(value) ||
      isEmptyValue(formattedValue) ||
      formattedValue === emptyText);
  const normalizedContent = isEmpty ? emptyText : displayContent;
  const normalizedLines = lines === 2 ? 2 : 1;
  const classes = [
    "prism-truncated-text",
    `prism-truncated-text--lines-${normalizedLines}`,
    isEmpty ? "prism-truncated-text--empty" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (isEmpty) {
    return <span className={classes}>{normalizedContent}</span>;
  }

  return (
    <Tooltip
      placement="topLeft"
      title={
        <span className="prism-truncated-text__tooltip">
          {tooltipContent ?? formattedValue}
        </span>
      }
    >
      <span className={classes}>{normalizedContent}</span>
    </Tooltip>
  );
};

export default PrismTruncatedText;
